import { Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
// import ScrollMemory from "react-router-scroll-memory";

import ScrollToTop from "./elements/ScrollToTop";

import Container from "./Container";
// import OAuthEnd from "./auth/FirebaseOAuthEnd";
// import OAuthStart from "./auth/FirebaseOAuthStart";
import MrLogin from "./auth/MrLogin";
// import PrivateRoute from "./auth/PrivateRoute";

// const UnderConstruction = lazy(() => import("./common/UnderConstruction"));

const RawRouter = () => {
  return (
    <HelmetProvider>
      <Router>
        {/* <ScrollMemory /> */}
        <ScrollToTop />

        <Suspense fallback={<></>}>
          <Routes>
            {/* {process.env.REACT_APP_ENV === "production-disabled" && (
              <Route path="*" element={<UnderConstruction />} />
            )} */}
            {/* <Route
              path="/oauth/kakao"
              element={<PrivateRoute element={<OAuthStart />} />}
            />
            <Route path="/callbacks/kakao/sign-in" element={<OAuthEnd />} /> */}
            <Route path="/callbacks/mrlogin" element={<MrLogin />} />
            <Route path="*" element={<Container />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
};

export default RawRouter;
